<div class="markers-container" [ngClass]="{'vertical-layout': verticalLayout}">
	<div *ngFor="let marker of visibleMarkers$ | async" class="marker-container" [ngClass]="{'ai-style': aiStyle}">
		<marker
			[aiStyle]="aiStyle ? aiStyle : marker.is_ai_marker"
			[marker]="marker"
			[withCount]="withCount"
			[withName]="withName">
		</marker>
		<span *ngIf="withCount">
			{{marker.count}}
		</span>
	</div>

	<div *ngIf="showOverflow$ | async" class="overflow-indicator" translate="common_plus-more" [translateParams]="{count: hiddenCount$ | async}"></div>
</div>
